import { Alert, AlertDescription } from '@/components/ui/alert.js';
import type { CoachCsvApplySummary, CoachCsvDryRunResult, UpsertCoachUsersCsvResult } from '@airreading/common/data';

import { CoachCsvImportSummary } from './coach-csv-import-summary.js';

export type CoachCsvImportResult =
  | {
      type: 'success';
      summary: CoachCsvDryRunResult | NonNullable<UpsertCoachUsersCsvResult['summary']>;
      isDryRun: boolean;
    }
  | { type: 'error'; message: string };

export function CoachCsvImportResultView({ result }: { result: CoachCsvImportResult | null }) {
  if (!result) {
    return null;
  }

  if (result.type === 'error') {
    return (
      <Alert variant="destructive">
        <AlertDescription className="whitespace-pre-line">{result.message}</AlertDescription>
      </Alert>
    );
  }

  const summary: CoachCsvApplySummary & { totals?: CoachCsvDryRunResult['totals'] } =
    'totals' in result.summary
      ? result.summary
      : {
          ...result.summary,
        };

  return <CoachCsvImportSummary summary={summary} isDryRun={result.isDryRun} />;
}
